import { useDropdownMenu } from 'react-overlays';
import { AppDropDownListCombinedProps } from './types';

// MANUAL OVERRIDE
const usePresenter = (props: AppDropDownListCombinedProps): AppDropDownListCombinedProps => {
  const [menuProps, { toggle }] = useDropdownMenu({
    flip: true,
    offset: props.offset || [0, 0], 
  });
  const items = props.appDropDownItems?.map((item) => {
    return {
      ...item,
      onClick: (event) => {
        event.preventDefault();
        if (toggle) {
          toggle(false);
        }
        if (item.onClick) {
          item.onClick();
        }
      },
    };
  });

  return {
    ...props,
    ...menuProps,
    appDropDownItems: items,
    role: 'menu',
  };
};

export default usePresenter;
